import Vue from 'vue';

Vue.component('fnb-dashboard-index', () =>
    import(/* webpackChunkName: 'index' */ './dashboard-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory-fnb/dashboard/index.js